module.exports = __webpack_public_path__ + "static/media/perfil_default.59da78cc.png";